import React from "react";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import RecentlyIssuedCertificates from "../../components/DashboardPageComponents/RecentlyIssuedCertificates";
import { automationTestIds } from "../../testing/automationTestIds";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const IssuedCertificatesPage = () => {
  const { t } = useTranslation(["dashboard"]);
  const navigate = useNavigate();

  const handleDashboardClick = () => {
    navigate("/issuer/discover");
  };

  return (
    <div
      id={pageRootTestIds.issuedCertificates}
      className="w-full mt-20 bg-cfSecondary min-h-screen"
    >
      <div className="w-full bg-cfSearchContainer flex justify-center py-[0.1rem] px-4">
        <div className="flex items-center min-h-[2.5rem] lg:min-h-[4rem] w-full min-w-0">
          <div
            id={automationTestIds.issuedCertificatesBreadcrumb}
            className="flex items-center gap-2 text-sm text-gray-500 truncate min-w-0 max-w-full"
            aria-label="Breadcrumb"
          >
            <button
              type="button"
              id={automationTestIds.issuedCertificatesBack}
              onClick={handleDashboardClick}
              className="hover:text-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimaryButton focus-visible:ring-offset-2 rounded-sm"
            >
              {t("dashboard:breadcrumb_dashboard")}
            </button>
            <ChevronRight
              className="h-4 w-4 shrink-0 text-cfTextBreadcrumbDisabled"
              aria-hidden="true"
            />
            <span
              id={`${automationTestIds.issuedCertificatesBreadcrumb}-current`}
              className="text-gray-800 font-medium truncate"
              title={t("dashboard:issued_certificates_page_title")}
            >
              {t("dashboard:issued_certificates_page_title")}
            </span>
          </div>
        </div>
      </div>

      <div className="px-4 pt-4 pb-6">
        <div className="mb-3">
          <h1 className="text-2xl md:text-3xl font-bold text-cfHeadingText">
            {t("dashboard:issued_certificates_page_title")}
          </h1>
          <p className="mt-1 text-sm text-gray-500 max-w-2xl">
            {t("dashboard:issued_certificates_page_subtitle")}
          </p>
        </div>

        <RecentlyIssuedCertificates
          pageLimit={10}
          showPagination
          showViewAll={false}
          showTitle={false}
          showSubtitle={false}
          compact
          dataTestId={automationTestIds.issuedCertificates}
          tableTestId={automationTestIds.issuedCertificatesTable}
        />
      </div>
    </div>
  );
};

export default IssuedCertificatesPage;
